const radii = {
  none: "0rem",
  // 0px
  subtle: "0.1875rem",
  // 3px,
  round: "50%",
  pill: "9999px",
  button: ".5rem",
  tooltip: "0.25rem",
  popoverContent: "0.25rem",
  modal: "0.25rem",
  menuList: "0.25rem",
  textarea: "0.25rem",
  drawer: "1rem"
};

export { radii };
